import React, { useState, useEffect } from 'react'
import Sidebar from '../sidebar'
import NavLogo from '../NavLogo'
import ReportNavbar from './ReportNavbar'
import { MDBDataTable } from 'mdbreact'
import { ReportForwardDeposit, ReportMemberListApi } from '../../ApiFile'
import { Col, Row } from 'react-bootstrap'
import { Button } from '@mui/material'
import { toast } from 'react-toastify'
import * as XLSX from 'xlsx'
import jsPDF from 'jspdf'
import 'jspdf-autotable'
import MobileNavbarAdmin from '../pages/MobileNavbarAdmin'

const CarryForwardDeposit = () => {
  const [members, setMembers] = useState([])

  useEffect(() => {
    fetch(ReportForwardDeposit)
      .then((response) => response.json())
      .then((data) => setMembers(data))
      .catch((error) => console.error('Error fetching member list:', error))
  }, [])

  const rows = members.map((member, index) => ({
    serial: index + 1,
    member_id: member.member_id,
    name: member.name,
  }))

  const data = {
    columns: [
      {
        label: 'Serial No',
        field: 'serial',
        sort: 'asc',
      },
      {
        label: 'Member Id',
        field: 'member_id',
        sort: 'asc',
      },
      {
        label: 'Name',
        field: 'name',
        sort: 'asc',
      },
    ],
    rows: rows,
  }

  const handleExcelData = () => {
    const ws = XLSX.utils.json_to_sheet(rows)
    const wb = XLSX.utils.book_new()
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1')

    const wbout = XLSX.write(wb, { bookType: 'xlsx', type: 'array' })
    const blob = new Blob([wbout], { type: 'application/octet-stream' })

    const url = URL.createObjectURL(blob)
    const a = document.createElement('a')
    a.href = url
    a.download = 'CarryForward_Deposit_Data.xlsx'
    document.body.appendChild(a)
    a.click()
    document.body.removeChild(a)
    URL.revokeObjectURL(url)

    toast.success('Excel Sheet Downloaded !!!', {
      position: 'top-right',
      autoClose: 2000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
    })
  }

  const handlePdfData = () => {
    const doc = new jsPDF()
    const columns = data.columns.map((col) => col.label)
    const rowsData = rows.map((row) => [row.serial, row.member_id, row.name])

    const title = 'Carry-Forward Deposit Data'

    const pageWidth = doc.internal.pageSize.getWidth()
    const textWidth =
      (doc.getStringUnitWidth(title) * doc.internal.getFontSize()) /
      doc.internal.scaleFactor
    const x = (pageWidth - textWidth) / 2
    doc.text(title, x, 10)

    doc.autoTable({
      head: [columns],
      body: rowsData,
      startY: 20,
    })

    const blob = doc.output('blob')
    const url = URL.createObjectURL(blob)
    const a = document.createElement('a')
    a.href = url
    a.download = 'CarryForward_Deposit_Data.pdf'
    document.body.appendChild(a)
    a.click()
    document.body.removeChild(a)
    URL.revokeObjectURL(url)

    toast.success('PDF Downloaded !!!', {
      position: 'top-right',
      autoClose: 2000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
    })
  }

  return (
    <>
      {/* <Sidebar /> */}
      <div className="d-none d-md-block">
                           <Sidebar />
                         </div>
                   
                         <section className="home-section pb-5">
                            <NavLogo />
                   
                         <div className="d-block d-md-none">
                           <MobileNavbarAdmin />
                         </div>
        <ReportNavbar />

        <div className="member-list border">
          <Row className="m-0 p-0 pt-4 px-3">
            <Col
              className="rounded text-center py-2"
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                backgroundColor: 'white',
                border: '0px',
                alignItems: 'center',
                alignContent: 'center',
                color: 'maroon',
              }}
            >
              <div>
                <span style={{ color: 'maroon', fontSize: '18px' }}>
                  Carry-Forward Deposit List
                </span>
              </div>
              <div>
                <Button
                  className="mx-1 p-0"
                  style={{
                    border: '1px solid',
                    backgroundColor: '#3b9cfd',
                    color: 'white',
                  }}
                  onClick={() => handleExcelData()}
                >
                  Excel
                </Button>
                <Button
                  className="mx-1 p-0"
                  style={{
                    border: '1px solid',
                    backgroundColor: '#136fcb',
                    color: 'white',
                  }}
                  onClick={() => handlePdfData()}
                >
                  Pdf
                </Button>
              </div>
            </Col>
          </Row>

          <Row
            className="m-0 p-0 px-md-3 py-1 pb-5  w-100 mb-5"
            style={{ display: 'flex' }}
          >
            <Col
              className="m-0 p-0 px-3 py-3 rounded"
              style={{ background: 'white',overflowX: 'auto' }}
            >
              <MDBDataTable
                striped
                bordered
                className="custom-datatable"
                small
                data={data}
              />
            </Col>
          </Row>
        </div>
      </section>
    </>
  )
}

export default CarryForwardDeposit
